var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFormCheckboxDisabled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 15 15",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 1h13v13H1z",
    fill: "#D6D8DA",
    fillOpacity: 0.8,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#CAD2D8",
    x: 0.5,
    y: 0.5,
    width: 14,
    height: 14,
    rx: 1
  }))));
}

export default "data:image/svg+xml;base64,bW9kdWxlLmV4cG9ydHMgPSAiZGF0YTppbWFnZS9zdmcreG1sO2Jhc2U2NCxQRDk0Yld3Z2RtVnljMmx2YmowaU1TNHdJaUJsYm1OdlpHbHVaejBpVlZSR0xUZ2lQejRLUEhOMlp5QjNhV1IwYUQwaU1UVndlQ0lnYUdWcFoyaDBQU0l4TlhCNElpQjJhV1YzUW05NFBTSXdJREFnTVRVZ01UVWlJSFpsY25OcGIyNDlJakV1TVNJZ2VHMXNibk05SW1oMGRIQTZMeTkzZDNjdWR6TXViM0puTHpJd01EQXZjM1puSWlCNGJXeHVjenA0YkdsdWF6MGlhSFIwY0RvdkwzZDNkeTUzTXk1dmNtY3ZNVGs1T1M5NGJHbHVheUkrQ2lBZ0lDQThkR2wwYkdVK1ptOXliUzFqYUdWamEySnZlQzFrYVhOaFlteGxaRHd2ZEdsMGJHVStDaUFnSUNBOFp5QnBaRDBpVUdGblpTMHhJaUJ6ZEhKdmEyVTlJbTV2Ym1VaUlITjBjbTlyWlMxM2FXUjBhRDBpTVNJZ1ptbHNiRDBpYm05dVpTSWdabWxzYkMxeWRXeGxQU0psZG1WdWIyUmtJajRLSUNBZ0lDQWdJQ0E4WnlCcFpEMGlabTl5YlMxamFHVmphMkp2ZUMxa2FYTmhZbXhsWkNJK0NpQWdJQ0FnSUNBZ0lDQWdJRHhuSUdsa1BTSndZWFJvTFRFdGJHbHVheUlnZEhKaGJuTm1iM0p0UFNKMGNtRnVjMnhoZEdVb01TNHdNREF3TURBc0lERXVNREF3TURBd0tTSWdabWxzYkQwaUkwUTJSRGhFUVNJZ1ptbHNiQzF2Y0dGamFYUjVQU0l3TGpnaUlHWnBiR3d0Y25Wc1pUMGlibTl1ZW1WeWJ5SStDaUFnSUNBZ0lDQWdJQ0FnSUNBZ0lDQThjbVZqZENCcFpEMGljR0YwYUMweElpQjRQU0l3SWlCNVBTSXdJaUIzYVdSMGFEMGlNVE1pSUdobGFXZG9kRDBpTVRNaVBqd3ZjbVZqZEQ0S0lDQWdJQ0FnSUNBZ0lDQWdQQzluUGdvZ0lDQWdJQ0FnSUNBZ0lDQThjbVZqZENCcFpEMGlVbVZqZEdGdVoyeGxJaUJ6ZEhKdmEyVTlJaU5EUVVReVJEZ2lJSGc5SWpBdU5TSWdlVDBpTUM0MUlpQjNhV1IwYUQwaU1UUWlJR2hsYVdkb2REMGlNVFFpSUhKNFBTSXhJajQ4TDNKbFkzUStDaUFnSUNBZ0lDQWdQQzluUGdvZ0lDQWdQQzluUGdvOEwzTjJaejQ9Ig==";
export { SvgFormCheckboxDisabled as ReactComponent };